import React from "react";
import { Stack, Box, TextField, IconButton, Button, Autocomplete, Select, MenuItem, InputLabel, FormControl, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

function calcularValor(tempo, funcionario) {
  if (
    !tempo ||
    !funcionario ||
    !funcionario.salario ||
    !funcionario.horasMes ||
    funcionario.horasMes === 0
  ) return "";
  const [h, m] = tempo.split(":").map(Number);
  const horas = (isNaN(h) ? 0 : h) + ((isNaN(m) ? 0 : m) / 60);
  const custoHoraEmployee = funcionario.salario / funcionario.horasMes;
  if (isNaN(custoHoraEmployee) || isNaN(horas)) return "";
  return (horas * custoHoraEmployee).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

const EditableTaskList = ({ items, onChange, funcionarios, itensDescricao }) => {
    const handleChange = (index, key, value) => {
        const next = items.map((it, i) => {
            if (i === index) {
                const updated = { ...it, [key]: value };
                if (key === "tempo" || key === "responsavel") {
                    const funcionario = funcionarios.find(f => f.nome === (key === "responsavel" ? value : updated.responsavel));
                    updated.valor = calcularValor(key === "tempo" ? value : updated.tempo, funcionario);
                }
                return updated;
            }
            return it;
        });
        onChange(next);
    };

    const addItem = () => onChange([...(items || []), { descricao: "", responsavel: "", tempo: "",valor: 0 }]);
    const removeItem = (index) => onChange(items.filter((_, i) => i !== index));

    return (
    <Box sx={{ width: "100%" }}>
        <Stack spacing={1}>
        {(items || []).map((it, idx) => {
            const descricaoAdicionadas = items.map(item => item.descricao).filter(Boolean);
            const opcoesDisponiveis = (itensDescricao || []).filter(
                desc => !descricaoAdicionadas.includes(desc) || desc === it.descricao
            );
            const funcionario = funcionarios.find(f => f.nome === it.responsavel);
            return (
            <Stack key={idx} direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
                <Autocomplete
                    size="small"
                    sx={{ flex: 2, minWidth: 180 }}
                    freeSolo
                    options={opcoesDisponiveis || []}
                    value={it.descricao}
                    onChange={(_, value) => handleChange(idx, "descricao", value)}
                    onInputChange={(_, value) => handleChange(idx, "descricao", value)}
                    renderInput={(params) => (
                        <TextField {...params} size="small" label="Descrição" fullWidth />
                    )}
                />
                <FormControl size="small" sx={{ flex: 2, minWidth: 140 }}>
                    <InputLabel>Responsável</InputLabel>
                    <Select
                        label="Responsável"
                        value={it.responsavel}
                        onChange={e => handleChange(idx, "responsavel", e.target.value)}>
                        {funcionarios.map(f => (
                        <MenuItem key={f.nome} value={f.nome}>{f.nome}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    size="small"
                    label="Tempo (hh:mm)"
                    value={it.tempo}
                    onChange={e => {
                        let val = e.target.value.replace(/[^0-9:]/g, "");
                        if (/^\d{0,2}:?\d{0,2}$/.test(val)) {
                        handleChange(idx, "tempo", val);
                        }
                    }}
                    sx={{ flex: 1, minWidth: 80 }}
                    fullWidth
                    placeholder="01:30"
                />
                <TextField
                    size="small"
                    label="Valor"
                    value={it.valor || calcularValor(it.tempo, funcionario)}
                    slotProps={{ readOnly: true }}
                    sx={{ flex: 1, minWidth: 80 }}
                    fullWidth
                />
                <IconButton color="error" onClick={() => removeItem(idx)} sx={{ flex: "none" }}>
                    <DeleteIcon />
                </IconButton>
            </Stack>
            );
        })}
        </Stack>
        <Button startIcon={<AddIcon />} variant="outlined" onClick={addItem} sx={{ mt: 1, width:"100%" }}>
            Adicionar
        </Button>
    </Box>
    );
};

export default EditableTaskList;